if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      // this.form.querySelector('[name="items[0][id]"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');

      this.initOthers();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      submitButton.setAttribute('disabled', true);
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      document.querySelector('.mini-cart-overlay').style.opacity = "1";
      document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";
      
      //Check if Recharge Widget exists and find active subscription input
      let activeOption = document.querySelector('.rc-option--active');
      let checkSubscribe = activeOption ? activeOption.querySelector('input').value : null;

      const customRechargeWidget = this.form.querySelector('custom-recharge-widget');

      if (window.ReChargeWidget && !customRechargeWidget) {
        if (checkSubscribe === 'subsave') {
          let inputElement = activeOption.querySelector('input[value="subsave"]');
          let nameValue = inputElement.name;
          let number = nameValue.match(/\d+/)[0]; // Extract the number from the name

          document.querySelector('[name="items[0][selling_plan]"]').value = number;
          document.querySelector('[name="items[0][selling_plan]"]').disabled = false;
        } else if (checkSubscribe === 'onetime') {
          document.querySelector('[name="items[0][selling_plan]"]').disabled = true;
        }
      }

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      submitButton.querySelector('span').classList.remove("fadeInDown");
      submitButton.querySelector('span').classList.add("animated", "zoomOut");

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      const itemsMap = new Map();
      const preservedFields = [];
      
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^items\[(\d+)]\[(\w+)]$/);
        if (match) {
          const originalIndex = parseInt(match[1], 10);
          const field = match[2];
      
          if (!itemsMap.has(originalIndex)) {
            itemsMap.set(originalIndex, {});
          }
      
          itemsMap.get(originalIndex)[field] = value;
        } else {
          preservedFields.push([key, value]);
        }
      }
      
      const sortedItems = [...itemsMap.entries()]
        .sort((a, b) => a[0] - b[0])
        .map(entry => entry[1]);
      
      const newFormData = new FormData();
      
      sortedItems.forEach((item, newIndex) => {
        for (const key in item) {
          newFormData.append(`items[${newIndex}][${key}]`, item[key]);
        }
      });
      
      preservedFields.forEach(([key, value]) => {
        newFormData.append(key, value);
      });
      config.body = newFormData;

      var cartObj = this.cartNotification;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          cartObj.renderContents('FROM_ADD_TO_CART');
          // document.dispatchEvent(new CustomEvent('addToCartSuccess'));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-disabled');
           // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          submitButton.querySelector('.checkmark').classList.add('checkmark-active');

          window.setTimeout(function () {
            submitButton.querySelector('.checkmark').classList.remove('checkmark-active');
            submitButton.querySelector('span').classList.remove('zoomOut');
            submitButton.querySelector('span').classList.add('fadeInDown');
          }, 1000);

          // edit button checkbox refresh and disabled
          if (document.querySelectorAll('.add_on_products .product_inner .checkbox input[type="checkbox"]')) {
            document.querySelectorAll('.add_on_products .product_inner .checkbox input[type="checkbox"]').forEach(function (check) {
              check.checked = false;
            })
          }

          if (document.querySelectorAll('.pair_with_products .product_inner .edit_var')) {
            document.querySelectorAll('.pair_with_products .product_inner .edit_var').forEach(function (edit) {
              edit.classList.add('hide')
            })
          }

          if (document.querySelectorAll('.product-form input[data-var]')) {
            document.querySelectorAll('.product-form input[data-var]').forEach(function (inputs) {
              inputs.disabled = true
            })
          }

          // after add to cart refresh radios
          let colorRadios = document.querySelectorAll(".edit_variant_popup .set_of_variants input[name='var-color']");
          if (colorRadios) {
            var firstEnabledButton = Array.from(colorRadios).find(function (button) {
              return !button.disabled;
            });

            if (firstEnabledButton) {
              firstEnabledButton.checked = true;
              firstEnabledButton.click()
            }
          }

          let setRadios = document.querySelectorAll(".edit_variant_popup .set_of_variants input[name='var-select-your-set']");
          if (setRadios) {
            var firstEnabledButtons = Array.from(setRadios).find(function (button) {
              return !button.disabled;
            });

            if (firstEnabledButtons) {
              firstEnabledButtons.checked = true;
              firstEnabledButtons.click()
            }
          }

        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    initOthers(){
      // Adddon
      var addonCheckbox = document.getElementById('prodAddOnBrushChck');
      var addonInputQty = document.querySelector('input[name="items[1][quantity]"]');
      var addonInputId = document.querySelector('input[name="items[1][id]"]');
      if (addonCheckbox) {
        addEventListener('beforeunload', (event) => { addonCheckbox.checked = false });
        addonCheckbox.addEventListener('click', event => {
          if (event.target.checked) {
            addonInputQty.disabled = false;
            addonInputId.disabled = false;
          } else {
            addonInputQty.disabled = true;
            addonInputId.disabled = true;
          }
        });
      }
      
      // addon products tabs
      let addon_tabs = document.querySelectorAll('.add_on_header_tabs h5.tab');
      let discounted_product_el = document.querySelector('.buy_with_discount_products')
      let pair_with_products = document.querySelector('.pair_with_products')
      
      if (addon_tabs) {
        addon_tabs.forEach((tab) => {
          tab.addEventListener('click', function (event) {
            let data_tab = event.target.dataset.tab;
            addon_tabs.forEach((title) => title.classList.remove('active'))
            event.target.classList.add('active')
            if (data_tab == 'paired') {
              pair_with_products.classList.remove('hide')
              discounted_product_el.classList.add('hide');
            } else {
              pair_with_products.classList.add('hide')
              discounted_product_el.classList.remove('hide')
            }
          })
        })
      }
      
      // edit popup on
      let edit_var = document.querySelectorAll('.pair_with_products .product_inner .edit_var');
      let close_popup = document.querySelectorAll('.edit_variant_popup .buttons span');
      let overlay = document.querySelector('.add_on_products .overlay');
      let announce_bar = document.querySelector('.shopify-section-announcement-bar');
      let header = document.querySelector('.shopify-section-header')
      if (edit_var) {
        edit_var.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            let popup_title = e.target.dataset.edit;
            document.querySelector(`.edit_variant_popup[data-pdp-title="${popup_title}"]`).classList.remove('hide');
            overlay.classList.remove('hide');
            document.body.style.overflow = 'hidden'
            header.style.transform = 'translateY(-100%)';
          })
        })
      }
      
      if (close_popup) {
        close_popup.forEach(function (close) {
          close.addEventListener('click', function (el) {
            document.querySelectorAll('.edit_variant_popup').forEach((e) => e.classList.add('hide'))
            overlay.classList.add('hide');
            document.body.style.overflow = 'auto'
            header.style.transform = 'translateY(0)';
      
            // radio reset
      
            let radios = el.target.closest('.edit_variant_popup').querySelectorAll(".set_of_variants input");
            if (radios) {
              var firstEnabledButton = Array.from(radios).find(function (button) {
                return !button.disabled;
              });
      
              if (firstEnabledButton) {
                firstEnabledButton.checked = true;
                firstEnabledButton.click()
              }
            }
      
          })
        })
      }
      
      // desc tab mobile hide show 
      
      let desc_tab = document.querySelectorAll('.add_on_products .desc_tab_mobile p.tab')
      
      if (desc_tab) {
        desc_tab.forEach(function (e) {
          e.addEventListener('click', function (el) {
            let next_el = el.target.nextSibling;
            next_el.nextElementSibling.classList.toggle('hide')
          })
        })
      }
      
      // unlocking add on products and locked
      
      let addon_checkbox = document.querySelectorAll('.add_on_products .product_inner .checkbox input[type="checkbox"]');
      
      addon_checkbox.forEach(function (check) {
        check.addEventListener('change', function (event) {
          let all_items_id = document.querySelectorAll('.product-form input[data-var]');
          all_items_id.forEach(function (input) {
            input.disabled = true;
      
            addon_checkbox.forEach(function (els) {
              if (els.checked) {
                if (els.closest('.product_inner').querySelector('.edit_var')) {
                  els.closest('.product_inner').querySelector('.edit_var').classList.remove('hide')
                }
                let checked_var = els.value;
      
                if (checked_var == input.dataset.var) {
                  input.disabled = false
                }
              } else {
                if (els.closest('.product_inner').querySelector('.edit_var')) {
                  els.closest('.product_inner').querySelector('.edit_var').classList.add('hide')
                }
              }
            })
          })
      
        })
      });
      
      // select current varaint from popup variants
      
      const select_button = document.querySelectorAll('.edit_variant_popup .buttons .select');
      let all_items = document.querySelectorAll('.product-form input[data-var]');
      let items_id_js = document.querySelectorAll('.product-form .item_id_js');
      let checkboxes_select = document.querySelectorAll('.add_on_products .product_inner .checkbox')
      if (select_button) {
        select_button.forEach(function (btn) {
          btn.addEventListener('click', function (event) {
            let choosen_var = event.target.closest('.edit_variant_popup').querySelector('.set_of_variants input:checked').getAttribute('id');
            let current_product = event.target.closest('.edit_variant_popup').dataset.pdpTitle
            const close_trigger = event.target.closest('.buttons').querySelector('span');
            if (all_items) {
              all_items.forEach(function (item) {
                if (item.dataset.productTitle === current_product) {
                  item.dataset.var = choosen_var
                }
      
                if (item.classList.contains('item_id_js')) {
                  if (item.dataset.productTitle === current_product) {
                    item.value = choosen_var
                  }
                }
              });
            }
      
            if (checkboxes_select) {
              checkboxes_select.forEach(function (checks) {
                if (checks.dataset.titles === current_product) {
                  checks.querySelector('input[type="checkbox"]').value = choosen_var
                }
              })
            }
      
            //for closing the popup after update the variant
            document.querySelectorAll('.edit_variant_popup').forEach((e) => e.classList.add('hide'))
            overlay.classList.add('hide');
            document.body.style.overflow = 'auto'
            header.style.transform = 'translateY(0)';
          })
        })
      }
      
      
      // on edit popup variants click meta content changed based on variant
      const set_of_variants = document.querySelectorAll('.edit_variant_popup .set_of_variants input[type="radio"]');
      
      if (set_of_variants) {
        set_of_variants.forEach(function (inputs) {
          inputs.addEventListener('click', function (els) {
            let current_var_el = els.target.closest('.edit_variant_popup').querySelector('.variants_title h5');
            let current_var = els.target.closest('.image').querySelector('.variant_title_js');
            let var_update_default = els.target.closest('.single_product').querySelector('.product_meta p.variant')
            current_var_el.innerHTML = current_var.innerHTML;
            var_update_default.innerHTML = current_var.dataset.varTitle;
          })
        })
      }
    }
  });
}
